(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('quote-split', {
            parent: 'entity',
            url: '/quote-split?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.quoteSplit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quote-split/quote-splits.html',
                    controller: 'QuoteSplitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quoteSplit');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('enum');
                    return $translate.refresh();
                }]
            }
        })
        .state('quote-split-detail', {
            parent: 'entity',
            url: '/quote-split/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.quoteSplit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quote-split/quote-split-detail.html',
                    controller: 'QuoteSplitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quoteSplit');
                    $translatePartialLoader.addPart('enum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QuoteSplit', function($stateParams, QuoteSplit) {
                    return QuoteSplit.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('quote-split.new', {
            parent: 'quote-split',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', 'QuoteSplitModalService', function($state, QuoteSplitModalService) {
                QuoteSplitModalService.openCreateDialog(null, null).result.then(function() {
                    $state.go('quote-split', null, { reload: true });
                }, function() {
                    $state.go('quote-split');
                });
            }]
        })
        .state('quote-split.edit', {
            parent: 'quote-split',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quote-split/quote-split-dialog.html',
                    controller: 'QuoteSplitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QuoteSplit', function(QuoteSplit) {
                            return QuoteSplit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quote-split', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quote-split.delete', {
            parent: 'quote-split',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quote-split/quote-split-delete-dialog.html',
                    controller: 'QuoteSplitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QuoteSplit', function(QuoteSplit) {
                            return QuoteSplit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quote-split', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
